import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  questionsServerFiltersSelector,
  searchSelector,
} from '../store/selectors';
import { fromDateStr, toDateStr } from '../../../helpers/utcDate';
import { equalObjProps } from '../store/utils';

const generateParams = (data) => {
  const {
    period: [fromDate, toDate],
    ...otherData
  } = data;

  return {
    fromDate: fromDateStr(fromDate),
    toDate: toDateStr(toDate),
    onlyNeedAnswer: false,
    ...otherData,
  };
};

const generateSearchParams = (search) =>
  isNaN(Number(search)) ? { search } : { questionNum: search };

const useQuestionsQueryParams = () => {
  const serverFilters = useSelector(
    questionsServerFiltersSelector,
    equalObjProps
  );
  const searchVal = useSelector(searchSelector);

  return useMemo(
    () =>
      searchVal
        ? generateSearchParams(searchVal)
        : generateParams(serverFilters),
    [searchVal, JSON.stringify(serverFilters)]
  );
};

export default useQuestionsQueryParams;
